import { Map, List, fromJS } from "immutable";
import * as cm from "country-currency-map";

export const config = Map({
  languages: fromJS([
    { name: "English", value: "gb" },
    { name: "Bulgarian", value: "bg" },
    { name: "Czech", value: "cs" },
    { name: "Danish", value: "dk" },
    { name: "Spanish", value: "es" },
    { name: "Greek", value: "el" },
    { name: "Finnish", value: "fi" },
    { name: "French", value: "fr" },
    { name: "French Canadian", value: "fr-ca" },
    { name: "Hungarian", value: "hu" },
    { name: "Indonesian", value: "id" },
    { name: "Italian", value: "it" },
    { name: "Japanese", value: "jp" },
    { name: "Korean", value: "ko" },
    { name: "Dutch", value: "nl" },
    { name: "Norwegian", value: "no" },
    { name: "Polish", value: "pl" },
    { name: "Portuguese from Portugal", value: "pt-pt" },
    { name: "Portuguese from Brazil", value: "pt-br" },
    { name: "Romanian", value: "ro" },
    { name: "Russian", value: "ru" },
    { name: "Slovakian", value: "sk" },
    { name: "Vietnam", value: "vt" },
    { name: "Swedish", value: "sv" },
    { name: "Thai", value: "th" },
    { name: "Turkish", value: "tr" },
    { name: "Taiwan", value: "tw" },
    { name: "Simplified Chinese", value: "zh" },
    { name: "Traditional Chinese", value: "zh_tw" },
    { name: "German", value: "de" },
  ]),

  // the new format will add the 'value' property with the abbr property value
  // as the new select format requires a 'name' and a 'value' and uses the 'value'
  // as the outcome of the selected element
  currencies: fromJS(
    cm.getCurrencyList().map((currency) => ({
      ...currency,
      value: currency.abbr,
    }))
  ),
  max_users: 1000,
});

export const blackList = List(["demo.playzido.com"]);

/**
 * QA Links
 *
 * https://confluence.playzido.com/display/PW/Wrapper+2.0.0+QA+Links
 */
export const qaLinks = fromJS([
  {
    name: "1 - clock left test",
    value:
      "&menu-options.sound=true&menu-options.paytable=true&menu-options.help=true&menu-options.turbo=true&menu-options.lobby=true&menu-options.deposit=true&menu-options.realPlay=true&menu-options.backgroundSound=true&components.gameplayID=true&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=false&components.clock=true&components.clockPosition=left&autoplay.lossLimitMandatory=true&autoplay.singleWinLimitMandatory=false&autoplay.jackpotWinVisible=true&autoplay.maximumNumberPlays=25&autoplay.numberPlays=[2,5,10,15,20,25]&autoplay.lossLimitMultiplier=[5,10,15,20,25,50,-100]&autoplay.singleWinLimitMultiplier=[5,10,25,50,100,-100]&autoplay.jackpotWinDefaultValue=off&depositURL=http://google.com/deposit&realplayURL=http://google.com/realplay&showMenuButton=true&allowDevTools=true&startMuted=false",
  },
  {
    name: "2 - clock in info bar test",
    value:
      "&components.gameplayID=true&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=true&components.clock=true&components.clockPosition=infobar",
  },
  {
    name: "3 - infobar on bottom test",
    value:
      "&components.gameplayID=true&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=true&components.clock=true&components.clockPosition=infobar",
  },
  {
    name: "4 - infobar on bottom, no overlay",
    value:
      "&components.gameplayID=true&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=true&components.clock=true&components.clockPosition=infobar",
  },
  {
    name: "5 - all menu options",
    value:
      "&menu-options.lobby=true&lobbyURL=https://google.com&menu-options.sound=true&menu-options.paytable=true&menu-options.help=true&menu-options.turbo=true&menu-options.deposit=true&depositURL=https://google.com&menu-options.backgroundSound=true&menu-options.realPlay=true&realplayURL=https://google.com&demoMode=true&demoForceEnabled=true",
  },
  {
    name: "6 - overlay infobar on bottom",
    value:
      "&components.gameplayID=true&components.infoBar=true&components.infoBarOverlay=false&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=true&components.clock=true&components.clockPosition=infobar",
  },
  {
    name: "7 - all reality check options",
    value:
      "&realityCheckExitToLobby=true&realityCheckExitURL=https://www.google.com&realityCheckHistoryURL=https://google.com&realityCheckInterval=60&realityCheckCurrentTime=30&realityCheckTimeUnit=seconds",
  },
  {
    name: "8 - all reality check options with lobby url",
    value:
      "&realityCheckExitToLobby=true&lobbyURL=https://www.google.com&realityCheckHistoryURL=https://google.com&realityCheckInterval=60&realityCheckCurrentTime=30",
  },
  {
    name: "9 - no info bar clock top left",
    value:
      "&components.infoBar=false&components.clock=true&components.clockPosition=left&components.clockVerticalPosition=top&startMuted=true",
  },
  {
    name: "10 - no info bar clock top right",
    value:
      "&components.infoBar=false&components.clock=true&components.clockPosition=right&components.clockVerticalPosition=top&startMuted=true",
  },
  {
    name: "11 - no info bar clock bottom left",
    value:
      "&components.infoBar=false&components.clock=true&components.clockPosition=left&components.clockVerticalPosition=bottom&startMuted=true",
  },
  {
    name: "12 - no info bar clock bottom right",
    value:
      "&components.infoBar=false&components.clock=true&components.clockPosition=right&components.clockVerticalPosition=bottom&startMuted=true",
  },
  {
    name: "13 - info bar bottom clock in info bar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "14 - info bar bottom clock in info bar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "15 - info bar bottom clock in info bar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "16 - info bar bottom clock in info bar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "17 - info bar bottom clock top left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "18 - info bar bottom clock top left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "19 - info bar bottom clock top left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "20 - info bar bottom clock top left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "21 - info bar bottom clock top right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "22 - info bar bottom clock top right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "23 - info bar bottom clock top right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "24 - info bar bottom clock top right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=bottom&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "25 - info bar top clock in infobar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "26 - info bar top clock in infobar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "27 - info bar top clock in infobar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "28 - info bar top clock in infobar",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=infobar&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "29 - info bar top clock bottom left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "30 - info bar top clock bottom left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "31 - info bar top clock bottom left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "32 - info bar top clock bottom left",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=left&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "33 - info bar top clock bottom right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "34 - info bar top clock bottom right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "35 - info bar top clock bottom right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=false",
  },
  {
    name: "36 - info bar top clock bottom right",
    value:
      "&components.gameplayID=true&components.clock=true&components.clockPosition=right&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=false&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&startMuted=true&components.infoBarSplitBalance=true",
  },
  {
    name: "37 - network errors being handled normally",
    value:
      "&components.gameplayID=true&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=true&components.clock=true&components.clockPosition=infobar&networkErrorAsFatal=false",
  },
  {
    name: "38 - clock left test",
    value:
      "&menu-options.sound=true&menu-options.paytable=true&menu-options.help=true&menu-options.turbo=true&menu-options.lobby=true&menu-options.deposit=true&menu-options.realPlay=true&menu-options.backgroundSound=true&components.gameplayID=true&components.infoBar=true&components.infoBarPosition=top&components.infoBarOverlay=true&components.infoBarStake=true&components.infoBarCurrentBalance=true&components.infoBarTotalWin=true&components.infoBarClock=false&components.clock=true&components.clockPosition=left&autoplay.lossLimitMandatory=true&autoplay.singleWinLimitMandatory=false&autoplay.jackpotWinVisible=true&autoplay.maximumNumberPlays=25&autoplay.numberPlays=[2,5,10,15,20,25]&autoplay.lossLimitMultiplier=[5,10,15,20,25,50,-100]&autoplay.singleWinLimitMultiplier=[5,10,25,50,100,-100]&autoplay.jackpotWinDefaultValue=off&depositURL=http://google.com/deposit&realplayURL=http://google.com/realplay&showMenuButton=true&allowDevTools=true&startMuted=false&lobbyURL=https://www.google.com/",
  },
  {
    name: "39 - Demo force",
    value: "&demoMode=true&demoForceEnabled=true",
  },
  {
    name: "40 - Real play",
    value:
      "&menu-options.realPlay=true&realplayURL=https://google.com&showPromoScreen=true&timeToPromo=30",
  },
  {
    name: "41 - Jurisdiction with launcher delay",
    value: "&jurisdiction.agcc.showMessage=true&launcherTimeout=10000",
  },
  {
    name: "42 - Full autoplay settings",
    value:
      "&autoplay.isActive=true&autoplay.numberPlays=[0,10,25,50,100,150]&autoplay.maximumNumberPlays=150&autoplay.lossLimitMultiplier=[5,10,15,20,25,50,-1]&autoplay.lossLimitMandatory=true&autoplay.singleWinLimitMultiplier=[5,10,25,50,100,-1]&autoplay.singleWinLimitMandatory=false&autoplay.jackpotWinVisible=true&autoplay.jackpotWinDefaultValue=off&autoplay.onBonusFeature=false",
  },
]);



// WEBPACK FOOTER //
// ./src/config.js